<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove this discount ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmAkcd">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      akcd_encrid: null,
      akcd: {}
    }
  },
  methods: {
    open(akcd_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/getAkcd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getAkcd"
          },
          getAkcd: {
            akcd_encrid: akcd_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.akcd = res.data.getAkcd;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmAkcd() { 
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/rmAkcd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmAkcd"
          },
          rmAkcd: {
            akcd_encrid: this.akcd.akcd_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/syst/ref/akcd/searchAkcd/'); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmAkcd.text,
              color: res.data.rmAkcd.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

